import * as _ from 'lodash';

import * as types from './types';

export const studentBalanceInitialState = {
  fetching: false,
  submitting: false,
  error: null,
  successMessage: null,
  data: {
    TotalPay: 0,
    TotalPurchase: 0,
  },
};

export default (state = studentBalanceInitialState, action) => {
  switch (action.type) {
    case types.ACCOUNT_SETUP_STUDENT_BALANCE_RESET:
      return {
        ...studentBalanceInitialState,
      };

    case types.ACCOUNT_SETUP_GET_STUDENT_BALANCE:
      return {
        ...state,
        data: action.payload,
      };

    case types.ACCOUNT_SETUP_POST_STUDENT_BALANCE_SUCCESS:
      return {
        ...state,
        successMessage: 'Student balance changed successfully',
      };

    case types.ACCOUNT_SETUP_STUDENT_BALANCE_ERROR:
      if (_.has(action.payload, 'response.data')) {
        const error = action.payload.response.data.Errors[0];

        return {
          ...state,
          error,
        };
      }

      return {
        ...state,
        error: {
          Title: 'Error',
          Message: 'An error occurred with Change Balance. Please try again',
        },
      };

    case types.ACCOUNT_SETUP_STUDENT_BALANCE_FETCHING:
      return {
        ...state,
        fetching: action.payload,
      };

    case types.ACCOUNT_SETUP_STUDENT_BALANCE_SUBMITTING:
      return {
        ...state,
        submitting: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/accountsetup/state/changebalance/reducer.js